import { render, staticRenderFns } from "./MailTable.vue?vue&type=template&id=28e6bd3c&scoped=true"
import script from "./MailTable.vue?vue&type=script&lang=js"
export * from "./MailTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e6bd3c",
  null
  
)

export default component.exports